import React from 'react';
import ReactDOM from 'react-dom';
import VehicleApp from "./components/VehicleApp";

const fields = document.getElementsByTagName('input');
const bodyDamagesRegex = new RegExp(/\[body_damages\]/);
const imagesRegex = new RegExp(/\[images\]/);
let points;
let pointsFieldName;
let images;
let imagesFieldName;
for (let i in fields) {
  if (bodyDamagesRegex.test(fields[i].name)) {
    points = fields[i].value;
    pointsFieldName = fields[i].name;
  }
  if (imagesRegex.test(fields[i].name)) {
    images = fields[i].value;
    imagesFieldName = fields[i].name;
  }
}
if (points !== '') {
  points = JSON.parse(points);
} else {
  points = null;
}

if (images !== '') {
  images = JSON.parse(images);
} else {
  images = null;
}

const scheme = document.getElementById('vehicle-app').getAttribute('data-scheme');

ReactDOM.render(
  <VehicleApp scheme={scheme ? scheme : 'car'} files={images} points={points} pointsInputName={pointsFieldName}
              imagesInputName={imagesFieldName} />,
  document.getElementById('vehicle-app')
);
